import React from 'react';
import ContentBox from '../../common/ContentBox';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FundAllocationMap from './components/FundAllocationMap';
import FundAllocationGauge from './components/FundAllocationGauge';
import { useAppSelector } from '../../../store/reducers/store';
import FundAllocationBubbles from '../../common/FundAllocationBubbles';

const PortfolioAllocationTab: React.FC = () => {
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);
    const { t } = useTranslation();
    if (portfolio === undefined){
        return <></>;
    }
    return <>
        <ContentBox proportion={1}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsInvestmentSectorDistribution')}</Typography>
            <FundAllocationBubbles values={portfolio.sectors} />
        </ContentBox>
        <ContentBox proportion={1}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsInvestmentStageDistribution')}</Typography>
            <FundAllocationGauge stages={portfolio.stages} />
        </ContentBox>
        <ContentBox proportion={1}>
            <Typography fontSize={"18px"} lineHeight={"21.94px"} fontWeight={"600"}>{t('PortfolioDetailsInvestmentGeographicDistribution')}</Typography>
            <FundAllocationMap allocations={portfolio.splits} />
        </ContentBox>
    </>;
}

export default PortfolioAllocationTab;